export default "__VITE_ASSET__Cs$1YLif__"